import React from "react";
import NumbersUtil from "../util/NumbersUtil";
import { useTranslation } from "react-i18next";
import cartEmpty from '../icons/cartEmpty.svg';
import TicketsIcon from "../icons/TicketsIcon";
import ticketsIconEmpty from "../icons/ticketsIconEmpty.svg";

const AddToCart = (props) => {
    const {t} = useTranslation();
    return (
        <div className="marginLeft1 marginRight1 marginTopAuto marginBottom1 addToCartRow flexCenter">
            <button disabled={!NumbersUtil.allRowsFilled(props.rows, props.gameType)} className="button button--success bold roundSquare flexEnd flexCenter" onClick={props.addToCart}>

                {t('button.addToCart')}{" "}{props.calculatePrice()}
            </button>
        </div>
    );
};

export default AddToCart;